// hooks/usePageTitle.js
import { useEffect } from 'react';

export function usePageTitle(title) {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title;

        // Push to GTM dataLayer for tracking
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'page_view',
                page_title: title,
                page_location: window.location.href,
                page_path: window.location.pathname
            });
        }

        // Optional: restore previous title on unmount
        return () => {
            document.title = prevTitle;
        };
    }, [title]);
}